import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { SpecialtySelect } from "../healioGlobal/SpecialtySelect";
import { TopicFilter } from "../topicFilter/TopicFilter";
import { TopicAndCreditTypeFilter } from "../topicAndCreditTypeFilter/TopicAndCreditTypeFilter";
import { SubSpecialtySelect } from "../healioGlobal/SubSpecialtySelect";
import { ViewBySpecialty } from "../news/ViewBySpecialty";
import { ILandingPageLoadRequest } from "../../models/LandingPage/ILandingPageLoadRequest";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import Mustache from "mustache";
import { moduletracking } from "../../Wyanoke/ModuleTracking";
import { UiUtil } from "../../util/UiUtil";
import { ViewBySubSpecialty } from "../news/ViewBySubSpecialty";

export class LandingNoMasonry extends Component {

    public static readonly LoadNextPageEvent = "LandingNoMasonry.LoadNextPage";

    // default is page 2 since we are preloading page 1 server-side
    private readonly _articleItemTemplate: string | null = null;
    private _pageNumber: number = 2;
    private _loading: boolean = false;
    private _spinner: Element | null;
    private _listItemTemplate: string | null = null;
    private _lastKnownScroll: number | null = 0;
    private _lastRequestId: string | null = null;
    private _tempDivElement: JQuery<HTMLElement> = $("<div></div>");
    private _cardContainer: HTMLElement | null;
    private _loadMoreButton: Element | null = null;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);

        let pageNumber = this._element.dataset.pageNumber;
        if (pageNumber) {
            this._pageNumber = Number(pageNumber);
        }

        this._spinner = document.querySelector(".cme-spinner");

        let listItemTemplateElement = document.querySelector("#ListingItemTemplate");
        if (listItemTemplateElement) {
            const listingItemTemplateHtml = listItemTemplateElement.innerHTML.trim();
            this._tempDivElement.html(listingItemTemplateHtml);
            // tslint:disable-next-line: max-line-length
            if (this._tempDivElement.find('[data-card-element="article-template"]').length) {
                this._articleItemTemplate = this._tempDivElement.find('[data-card-element="article-template"]').html();
                // tslint:disable-next-line: max-line-length
                this._tempDivElement.find('[data-card-element="article-template"]').html("");
            }
            this._listItemTemplate = this._tempDivElement.html();
        }

        let cardContainer = this._element.querySelector<HTMLElement>(".card-container");
        this._cardContainer = cardContainer;

        document.addEventListener(LandingNoMasonry.LoadNextPageEvent, this.loadNextPage);

        let loadMoreButton = this._element.querySelector("[data-action='load more']");
        if (loadMoreButton) {
            this._loadMoreButton = loadMoreButton;
            loadMoreButton.addEventListener("click", () => this.loadNextPage());
        }
    }

    public async init(): Promise<void> {
        // todo: load card servince
    }

    public async loadNextPage(): Promise<void> {
        if (this._loading) {
            return;
        }
        try {
            this._loading = true;
            this.startSpinner();

            this._lastKnownScroll = window.scrollY;
            const context = this._pageContext;
            if (!context) {
                throw new Error("No page context");
            }

            const serviceName = this._element.dataset.serviceName
                ? this._element.dataset.serviceName
                : "";

            const service = context.getCardService(serviceName);
            if (!service) {
                throw new Error("No service found for key: " + serviceName);
            }

            if (!this._cardContainer) {
                throw new Error("No card container!");
            }

            let userId = "00000000-0000-0000-0000-000000000000";
            if (this._element.dataset.requireUserprofile === "True") {
                // we await user profile
                const profile = await WyanokeUtil.loadUserProfile(true, false);
                if (!profile) {
                    console.error("Profile is not loaded");

                    return;
                }
                userId = (profile.contactid || userId);
            }

            const specialtySelect: SpecialtySelect | null =
                context.componentFactory.getComponent(SpecialtySelect);

            const topicFilter: TopicFilter | null =
                context.componentFactory.getComponent(TopicFilter);

            const creditTypeFilter: TopicAndCreditTypeFilter | null =
                context.componentFactory.getComponent(TopicAndCreditTypeFilter);

            const subspecialtySelect: SubSpecialtySelect | null =
                context.componentFactory.getComponent(SubSpecialtySelect);

            const templates = this._element.dataset.templateIds
                ? this._element.dataset.templateIds
                : "";

            let specialty = specialtySelect
                ? specialtySelect.specialty
                : null;

            // sometimes we will use a 'view by specialty' component instead of the regular specialty select control
            if (!specialty) {
                const viewBySpecialty: ViewBySpecialty | null = context.componentFactory.getComponent(ViewBySpecialty);
                specialty = viewBySpecialty ? viewBySpecialty.specialty : null;
            }

            let topics;

            if (topicFilter) {
                topics = topicFilter
                    ? topicFilter.topics.map(topic => topic.topicId)
                    : null;
            } else if (creditTypeFilter) {
                topics = creditTypeFilter
                    ? creditTypeFilter.topics.map(topic => topic.topicId)
                    : null;
            } else {
                topics = null;
            }

            const creditTypes = creditTypeFilter
                ? creditTypeFilter.creditTypes.map(creditType => creditType.creditTypeId)
                : null;

            let subspecialty = subspecialtySelect
                ? subspecialtySelect.subspecialty
                : null;

            // sometimes we will use a 'view by subspecialty' component instead of the regular sub specialty select control
            if (!subspecialty) {
                const viewBySubSpecialty: ViewBySubSpecialty | null = context.componentFactory.getComponent(ViewBySubSpecialty);
                subspecialty = viewBySubSpecialty ? viewBySubSpecialty.subspecialty : null;
            }

            const requestId =
                Math.random()
                    .toString(36)
                    // tslint:disable-next-line: no-magic-numbers
                    .substring(2, 15) +
                Math.random()
                    .toString(36)
                    // tslint:disable-next-line: no-magic-numbers
                    .substring(2, 15);
            this._lastRequestId = requestId;

            const additionalParameters = this._element.dataset.additionalParameters
                ? this._element.dataset.additionalParameters
                : null;

            const pageId = this._element.dataset.pageId
                ? this._element.dataset.pageId
                : null;

            const configSettingName = this._element.dataset.configSettingName
                ? this._element.dataset.configSettingName
                : null;

            const page = this._pageNumber;
            const request: ILandingPageLoadRequest = {
                additionalParameters,
                page,
                pageId,
                requestId,
                templates,
                specialty,
                subspecialty,
                topics,
                userId,
                creditTypes,
                configSettingName
            };

            const loadPromise = service.load(request);

            const response = await loadPromise;

            if (!this._lastRequestId ||
                !response.requestId ||
                response.requestId !== this._lastRequestId) {
                return;
            }

            // tslint:disable-next-line: no-unsafe-any
            let cards = response.cards;

            if (this._listItemTemplate && typeof (response.cards) === "object") {
                // tslint:disable-next-line: no-unsafe-any
                cards = this.renderCardsFromTemplate(response.cards);
            }

            const frag = document.createDocumentFragment();
            const node = frag.appendChild(document.createElement("div"));
            node.innerHTML = cards;
            while (node.firstChild) {
                var id = String($(node.firstChild).data("itemId"));
                var count = $("[data-item-id='" + id + "']").length;
                console.log(id + ": " + count);
                if (id.length === 0 || count === 0) {
                    this._cardContainer.appendChild(node.firstChild);
                } else {
                    node.firstChild.remove();
                    console.log("Skipped: " + id);
                    console.log(id.length);
                }
            }

            await context.componentFactory.loadComponents(this._element);

            const knownSpecialty = Boolean(specialty);
            const action = knownSpecialty ? "add" : "remove";
            this._element.classList[action]("known-specialty");

            const spinnerWait = 60;

            this._pageNumber++;
            this.stopSpinner(spinnerWait, this._pageNumber <= response.total);


            if (this._lastKnownScroll && !WyanokeUtil.isMobile()) {
                window.scrollTo(0, this._lastKnownScroll);
            }


            moduletracking.AjaxTrackLinks(this._element, "Cards");

            this._loading = false;
        } catch (error) {
            console.error(error)
            this.stopSpinner(0);
            this._loading = false;
        }
    }

    private renderCardsFromTemplate(cards: any): string {
        let renderedCards = "";
        // tslint:disable-next-line: no-unsafe-any
        if (this._listItemTemplate) {
            for (let card of cards) {
                const renderedTemplate = Mustache.render(this._listItemTemplate, card);
                this._tempDivElement.html(renderedTemplate);
                if (card.Id === "") {
                    this._tempDivElement.find('[data-card-element="content"]').remove();
                } else {
                    this._tempDivElement.find('[data-card-element="ad"]').remove();
                    if (this._articleItemTemplate && card.Articles) {
                        // tslint:disable-next-line: no-unsafe-any
                        for (let article of card.Articles) {
                            const renderedArticle = Mustache.render(this._articleItemTemplate, article);
                            this._tempDivElement.find('[data-card-element="article-template"]').append(renderedArticle);
                        }
                    }
                }
                this._tempDivElement.find('[data-card-element="content"]')
                    .children().unwrap();
                renderedCards += UiUtil.replaceDataSrcWithSrcInImageTags(this._tempDivElement.html());
            };
        }

        return renderedCards;
    }

    private stopSpinner(timeout: number, showLoadMore: boolean = true): void {
        setTimeout(() => {
            if (this._spinner) {
                this._spinner.classList.remove("active");
            }

            if (this._loadMoreButton && showLoadMore) {
                this._loadMoreButton.classList.remove("d-none");
            }
        }, timeout);
    }

    private startSpinner(): void {
        if (this._spinner) {
            this._spinner.classList.add("active");
        }

        if (this._loadMoreButton) {
            this._loadMoreButton.classList.add("d-none");
        }
    }
}

ComponentFactory.registerComponent("LandingNoMasonry", LandingNoMasonry);
